import { ReactNode } from "react";

type SectionHeadingProps = {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  trailing?: ReactNode;
  id?: string;
  compact?: boolean;
};

export function SectionHeading({
  eyebrow,
  title,
  description,
  trailing,
  id,
  compact = false,
}: SectionHeadingProps) {
  return (
    <div className={`section-heading${compact ? " compact" : ""}`} data-reveal>
      <div>
        <span className="eyebrow">{eyebrow}</span>
        <h2 id={id}>{title}</h2>
      </div>
      {description && <p>{description}</p>}
      {trailing}
    </div>
  );
}
